// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { testInstanceAttributeId } from './TestInstanceAttribute';
import { operatorId } from './Operator';
import { z } from 'zod';
export const testTabularRowId = (z.number());
export const testTabularRow = z.object({
    id: testTabularRowId,
    test_instance_attribute_id: testInstanceAttributeId,
    sort_order: z.number(),
    index_value_text: z.string().nullable(),
    index_value_number: z.string().nullable(),
    index_value_timestamp: z.date().nullable(),
    data: z.unknown(),
    computed_data: z.unknown().nullable(),
    computed_errors: z.unknown().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    computed_units: z.unknown().nullable(),
});
export const testTabularRowInitializer = z.object({
    id: testTabularRowId.optional(),
    test_instance_attribute_id: testInstanceAttributeId,
    sort_order: z.number().optional(),
    index_value_text: z.string().optional().nullable(),
    index_value_number: z.string().optional().nullable(),
    index_value_timestamp: z.date().optional().nullable(),
    data: z.unknown().optional(),
    computed_data: z.unknown().optional().nullable(),
    computed_errors: z.unknown().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    computed_units: z.unknown().optional().nullable(),
});
export const testTabularRowMutator = z.object({
    id: testTabularRowId.optional(),
    test_instance_attribute_id: testInstanceAttributeId.optional(),
    sort_order: z.number().optional(),
    index_value_text: z.string().optional().nullable(),
    index_value_number: z.string().optional().nullable(),
    index_value_timestamp: z.date().optional().nullable(),
    data: z.unknown().optional(),
    computed_data: z.unknown().optional().nullable(),
    computed_errors: z.unknown().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    computed_units: z.unknown().optional().nullable(),
});
//# sourceMappingURL=TestTabularRow.js.map